import React, { useState, useEffect } from 'react';
import {
  CircularProgress,
  Typography,
  Button
} from '@material-ui/core';

import CourseWork from '../../models/CourseWork';
import Spec from '../../models/Spec';
import utils from '../../libs/utils';

export interface AssignmentSpecSummaryProps {
  courseId?: string,
  courseWorks?: CourseWork[]
}

export const AssignmentSpecSummary = (props: AssignmentSpecSummaryProps) => {
  const {courseId = ''} = props;
  const [specLists, setSpecLists] = useState<Spec[][]>([]);
  const [courseWorks, setCourseWorks] = useState<CourseWork[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const loadData = async () => {
    try {
      setIsLoading(true);
      setErrorMessage('');
      setCourseWorks([]);
      setSpecLists([]);

      if (courseId) {
        const data = await (() => {
          if (props.courseWorks)
            return props.courseWorks;
          return CourseWork.find({
            courseId: courseId
          });
        })();

        setCourseWorks(data);
        setSpecLists(await Promise.all(data.map(a => a.getSpecs())));
      }
    }
    catch (e) {
      setErrorMessage(utils.getRequestErrorMessage(e));
    }
    finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    (async() => await loadData())();
  }, [courseId]);


  if (isLoading)
    return (
      <div className="text-center">
        <CircularProgress size={35} />
      </div>
    );

  if (errorMessage)
    return (
      <div className="text-center">
        <Typography>
          <b>Something went wrong.</b>
        </Typography>
        <Typography>
          {errorMessage}
        </Typography>

        <Button type="button"
                color="primary"
                variant="outlined"
                size="small"
                onClick={() => loadData()}>
          Try Again
        </Button>
      </div>
    );

  if (!courseWorks.length)
    return (
      <div className="text-center">
        <p>No assignment/s found.</p>
      </div>
    );

  return (
    <div>
      <ul>
        {courseWorks.map((courseWork, index) => {
          const specs = specLists[index] || [];

          return (
            <li className="pb-3" key={courseWork.id}>
              <b>{courseWork.name} ({courseWork.id})</b>
              {!!specs.length && (
                <ul>
                  {specs.map(spec => (
                    <li key={spec.id}>{spec.id}</li>
                  ))}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
